import { Icon } from '@manychat/manyui'

import { IListMessageBlock, IBlock } from 'common/builder/blocks/blockInterfaces'
import { FlowChartButtonBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartButtonBuilder'
import {
  ConverterRule,
  BlockConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { FlowChartButtonConverter } from 'common/builder/components/chart/FlowChart/lib/utils/FlowChartButtonConverter'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { ButtonAppearance } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import { FlowChartListMessageBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartListMessageBlock'
import { BlockType } from 'common/builder/constants/BlockType'

export const ListMessageBlockWhatsAppConverterRule: ConverterRule<
  IListMessageBlock,
  FlowChartListMessageBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) => entity?.type === BlockType.WA_LIST_MESSAGE,

  convert: (entity: IListMessageBlock, { fields }) => ({
    id: entity.id,
    type: FlowChartBlockType.LIST_MESSAGE,
    data: {
      title: entity.content.header?.text
        ? replaceFieldsInString(entity.content.header.text, fields)
        : null,
      text: replaceFieldsInString(entity.content?.body, fields),
      footer: entity.content.footer ? replaceFieldsInString(entity.content.footer, fields) : null,
      button: new FlowChartButtonBuilder(`list_message_button_${entity.id}`)
        .withCaption(entity.content.button)
        .withAppearance(ButtonAppearance.MENU)
        .withIcon(Icon.Menu)
        .build(),
      sections: entity.sections.map(({ _oid: id, title, options }) => ({
        id,
        title,
        buttons: options.map(FlowChartButtonConverter.fromListMessageSectionOption),
      })),
    },
  }),
}
